module.exports = __webpack_public_path__ + "static/p2-ec92ec5246fbc903227283d731362cc4.png";